module.exports = __webpack_public_path__ + "static/media/icon_chat_active.97c7ca01.svg";